import { Injectable } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

import { PW_MIN_LENGTH } from '../constants/common';
import { RegisterFormControls } from '../entities/register-form';

const pwRegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&]).+$/;

@Injectable()
export class RegisterFormService {
    private _form: FormGroup = new FormGroup({});

    get form(): FormGroup {
        return this._form;
    }

    initForm(): void {
        this._form = new FormGroup({
            // [RegisterFormControls.EMAIL]: new FormControl('', {
            //     validators: [Validators.required, Validators.email],
            //     updateOn: 'blur'
            // }),
            [RegisterFormControls.PASSWORD]: new FormControl('', {
                validators: [Validators.required, Validators.minLength(PW_MIN_LENGTH), Validators.pattern(pwRegExp)],
                updateOn: 'blur'
            }),
            [RegisterFormControls.PASSWORD_REPEAT]: new FormControl('', {
                validators: [this.createPasswordStrengthValidator()],
                updateOn: 'blur'
            })
        });
    }

    createPasswordStrengthValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const value = control.value;

            if (!value) {
                return { required: true };
            }

            const password = this.form.getRawValue()[RegisterFormControls.PASSWORD];

            return password !== value ? { notEqual: true } : null;
        };
    }

    validateForm(): void {
        Object.values(this.form.controls).forEach(this.markForValidation);
        this.markForValidation(this.form);
    }

    private markForValidation(control: AbstractControl) {
        control.markAsDirty();
        control.markAsTouched();
        control.updateValueAndValidity();
    }
}
